import "./App.css";
import React, { useState } from "react";
import { createClient } from "pexels";
import axios from "axios";
import Results from "./Results";
import Photos from "./Photos";

export default function App() {
  let [keyword, setKeyword] = useState("");
  let [results, setResults] = useState(null);
  let [photos, setPhotos] = useState(null);

  function handleResponse(response) {
    setResults(response.data[0]);
  }
  function handleError() {
    setResults({ error: true });
  }

  function handlePexelsResponse(response) {
    setPhotos(response.photos);
  }
  function handlePhotoError() {
    setPhotos(null);
  }

  function handleSearch(response) {
    setKeyword(response.target.value);
  }

  function handleSubmit(event) {
    event.preventDefault();
    setPhotos(null);

    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
    axios.get(apiUrl).then(handleResponse).catch(handleError);

    const client = createClient(
      "XLszUfpjFvMZQKxsA0eyO0M2CjvhRD7cnhL5IWkfQMuCDlQaz9gNIc2b"
    );
    client.photos
      .search({ query: keyword, per_page: 9 })
      .then(handlePexelsResponse)
      .catch(handlePhotoError);
  }

  return (
    <div className="App">
      <header className="main-header">
        <h1>Dictionary app</h1>
        <h3>What do you want to look up?</h3>
        <form className="search" onSubmit={handleSubmit}>
          <input
            className="form-control"
            type="search"
            placeholder="Search"
            autoFocus={true}
            onChange={handleSearch}
          />
        </form>
        <div className="example-words subtitle-font">
          i.e. dog, beer, game,...etc.
        </div>
      </header>
      <div className="dictionary">
        <Results results={results} />
        <Photos photos={photos} />
      </div>

      <footer className="subtitle-font">
        Coded by Yoshino Bollen and is {""}
        <a
          href="https://github.com/yoshino822/React_AddsOn_dictionary-project"
          target="_blank"
          rel="noreferrer"
        >
          open-sourced on GitHub
        </a>
        {""} and {""}
        <a
          href="https://silver-tanuki-5ff03a.netlify.app/"
          target="_blank"
          rel="noreferrer"
        >
          hosted on Netlify
        </a>
      </footer>
    </div>
  );
}
